export default __webpack_public_path__ + "static/media/enterpriseApp.439592be.svg";